import React from 'react';
import { services } from '../data/mock';
import { Wind, Shirt, Blend, Sandwich, Coffee, Fan } from 'lucide-react';

const iconMap = {
  vacuum: Wind,
  iron: Shirt,
  blender: Blend,
  sandwich: Sandwich,
  coffee: Coffee,
  hairdryer: Fan
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-[#1a1c1b]">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-[#888680] text-sm font-medium uppercase tracking-wide mb-4 block">
            Hizmetlerimiz
          </span>
          <h2 className="text-[#f97316] font-black text-4xl md:text-6xl uppercase leading-[0.85] mb-6">
            Tamir Ettiğimiz<br />Cihazlar
          </h2>
          <p className="text-[#888680] text-lg leading-relaxed">
            Tüm marka ve modellerde profesyonel tamir hizmeti sunuyoruz.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon] || Wind;
            return (
              <div
                key={service.id}
                className="group bg-[#302f2c] border border-[#4a2a10]/50 p-8 transition-all duration-300 hover:bg-[#4a2a10] hover:border-[#4a2a10]"
              >
                <div className="w-14 h-14 bg-[#4a2a10] group-hover:bg-[#f97316] rounded-full flex items-center justify-center mb-6 transition-colors duration-300">
                  <IconComponent size={24} className="text-[#f97316] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-[#f97316] font-bold text-xl mb-3">
                  {service.title}
                </h3>
                <p className="text-[#888680] text-base leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
